import { useSearchParams, useSelectedLayoutSegment } from 'next/navigation'
import React, { useState, useEffect, Suspense } from 'react'
import classNames from 'classnames'
import s from './style.module.scss'
import AppIcon from './app-icon'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { web, tgWeb } from '@/app/module/global'
import Image from 'next/image'
import u from './app-icon/u.png'
import { useTheme } from 'next-themes'
import { isMilian } from '@/app/module/global'
import useVisitorCheck from '@share/src/hook/useVisitorCheck'
import { useConfig } from '@share/src/configContext'

const commonNavClass = 'flex items-center relative rounded h-8 font-medium text-base cursor-pointer font-medium h-[43px] z-10 px-5'
let botId: any = '';
const NavHeader = ({ lang }: any) => {
  // 如果是这个botid，采用专门logo
  const searchParams = useSearchParams()
  const isDmzz = botId === 'tma_jgxy' ||  botId === 'tma_jgxx';
  const isFancyAI = botId === 'tma_fancy_lite-eng'
  const isMilianBot = botId === 'tma_ml_lite'
  const selectedSegment = useSelectedLayoutSegment()
  const { t } = useTranslation()
  const { resolvedTheme } = useTheme()
  const [mount, setMount] = useState(false)
  const {checkVisitor} = useVisitorCheck()
  const { config } = useConfig()
  const isReviewing = !!config?.is_reviewing


  useEffect(() => {
    botId = botId || localStorage.getItem('botid') || ''
    setMount(true)
  }, [])

  return <div className='flex items-center'>
    {
      tgWeb ? <Link className='md:ml-4 ml-2 items-center flex' href={isReviewing ? '#' : `/${lang}`} onClick={isReviewing ? (e) => e.preventDefault() : undefined} target='_self' prefetch={false}>
        {isFancyAI ? <>
          <AppIcon />
          <div className={classNames(
            "ml-0.5 mt-0.5 text-sm md:text-base py-2 md:p-0.5 md:py-1.5 font-bold",
            s.gradientText
          )}>FancyAI</div>
        </> : <div className='flex items-center'>
          {/* <span className={`${s.navTextGradient} font-delius-swash-caps text-2xl mr-[1px]`}>U</span> */}
          <Image src={u} width={18} alt='logo' className='mr-[2px]' unoptimized />
          <span className='font-crimson-text text-2xl'>honey</span>
        </div>}
      </Link> : <Link className='md:ml-4 ml-2 items-center flex' href={isReviewing ? '#' : (web || isMilian ? `/${lang}` : `https://t.me/HmAIMate`)} onClick={isReviewing ? (e) => e.preventDefault() : undefined} target={web || isMilian ? '_self' : '_blank'} prefetch={false}>
        {isDmzz? <>
        <Image src={'/image/logo1.svg'} width={24} height={24} alt="dmzz" unoptimized />
        <div className={classNames(
          "ml-0.5 mt-0.5 text-sm md:text-base py-2 md:p-0.5 md:py-1.5 font-bold",
          s.gradientText
        )}>{t('app.common.title1')}</div>
        </> : (isMilian || isMilianBot) ? <>
          <Image src={'/image/logo.png'} width={55} unoptimized height={22} alt="milian" />
        {/* <div className={classNames(
          "ml-0.5 mt-0.5 text-sm md:text-base py-2 md:p-0.5 md:py-1.5 font-bold",
          s.gradientText
        )}>{t('app.common.title2')}</div> */}
          </> : isFancyAI ? <>
          <AppIcon />
        <div className={classNames(
          "ml-0.5 mt-0.5 text-sm md:text-base py-2 md:p-0.5 md:py-1.5 font-bold",
          s.gradientText
        )}>FancyAI</div>
          </> : <>
          <AppIcon />
        <div className={classNames(
          "ml-0.5 mt-0.5 text-sm md:text-base py-2 md:p-0.5 md:py-1.5 font-bold",
          s.gradientText
        )}>{t('app.common.title')}</div>
          </>}
      </Link>
    }


    <div className='hidden md:flex items-center ml-1.5 sm:ml-7'>
      <Link href={`/${lang}`} className={classNames(
        commonNavClass,
        selectedSegment == null ? s.navActive : s.navUnActive,
      )}>
        {t('app.nav.index')}
      </Link>
      <Link href={`/${lang}/history/recent`} className={classNames(
        commonNavClass,
        selectedSegment === 'history' ? s.navActive : s.navUnActive,
      )}>
        {t('app.nav.chat')}
      </Link>
      {/* <Link href={`/${lang}/pay`} className={classNames(
        commonNavClass,
        selectedSegment === 'pay' ? s.navActive : s.navUnActive,
      )}>
        {t('app.nav.pay')}
      </Link> */}
      <Link href={`/${lang}/create/myroles`} className={classNames(
        commonNavClass,
        selectedSegment === 'create' ? s.navActive : s.navUnActive,
      )}>
        {t('app.nav.create')}
      </Link>
          <Link href={`/${lang}/earn`} className={classNames(
        commonNavClass,
        selectedSegment === 'earn' ? s.navActive : s.navUnActive,
      )}>
        {t('app.nav.earn')}
      </Link>
      <Link href={`/${lang}/img/album`} className={classNames(
        commonNavClass,
        selectedSegment === 'img' ? s.navActive : s.navUnActive,
      )}>
        {t('app.nav.album')}
      </Link>
      <Link href={`/${lang}/mine/setting`} className={classNames(
        commonNavClass,
        selectedSegment === 'mine' ? s.navActive : s.navUnActive,
      )}>
        {t('app.nav.mine')}
      </Link>
      {web && <Link href={`/${lang}/about`} className={classNames(
        commonNavClass,
        selectedSegment === 'about' ? s.navActive : s.navUnActive,
      )}>
        {t('app.footer.about')}
      </Link>}
    </div>
  </div>
}

const Page = ({ lang }: any) => {
  return (
    <Suspense fallback={<></>}>
      <NavHeader lang={lang} />
    </Suspense>
  )
}

export default Page

